<template>
  <div class="bk-selectBirthday">
    <div class="view-datePicker">
      <bk-datePicker 
        langCode_label="addCustomerProfile_birthMd"
        :value="birthMd"
        dropdownClassName="bkSelectBirthday-birthday-datePicker"
        langCode_placeholder="addCustomerProfile_dateofBirth"
        :format="customFormat"
        @change="handleDatePickerChange"
      />
    </div>
    <bk-input
      :value="birthYear"
      type="number"
      langCode_label="addCustomerProfile_birthYear"
      @change="handleInputChange"
      @blur="handleInputBlur"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name:"bk-selectBirthday",
  props:{
    birthMd:String,
    birthYear:[String, Number],
  },  
  methods:{
    customFormat(value){
      if(value){
        return dayjs(value).format('MM-DD')
      }
      return value;
    },
    handleInputChange(value=''){
      this.$emit('update:birthYear', value);
    },
    handleInputBlur(value){
      if(this.$bk_notNull(value) && value < 1900 || value > dayjs().year()){
        this.$bk_message.error({ langCode:'addCustomerProfil_msg_invalidYear'});
        this.handleInputChange()
      }
    },
    handleDatePickerChange(value){
      this.$emit('update:birthMd', value);
    }
  }
}
</script>

<style lang="less">
@import './bk-selectBirthday.less';
</style>